module.exports = __webpack_public_path__ + "img/moon.fb295263.jpg";